import React from 'react';
import { Calendar, BarChart3, Settings, Target, Compass } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const NavigationBar = ({ activeView, setActiveView, darkMode, theme, isDesktop, selectedPlan }) => {
  const { scoutEnabled } = useSettings();

  const allNavItems = [
    { k: 'plans', i: Target, l: selectedPlan ? 'Overview' : 'Plans' },
    { k: 'calendar', i: Calendar, l: 'Calendar' },
    { k: 'scout', i: Compass, l: 'Scout' },
    { k: 'analytics', i: BarChart3, l: 'Analytics' },
    { k: 'settings', i: Settings, l: 'Settings' }
  ];

  // Filter out scout if disabled
  const navItems = allNavItems.filter(item => item.k !== 'scout' || scoutEnabled);

  // Desktop: top horizontal nav
  if (isDesktop) {
    const desktopContainer = darkMode
      ? 'border-b border-slate-800/70 bg-slate-950/80 backdrop-blur-lg'
      : 'border-b border-slate-200 bg-white/90 backdrop-blur-lg';
    const desktopBaseBtn = 'px-4 py-3 rounded-2xl flex items-center gap-2 text-sm font-semibold transition-all duration-200';

    return (
      <div className={desktopContainer}>
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex gap-2 py-2">
            {navItems.map(({ k, i: I, l }) => {
              const isActive = activeView === k;
              const activeClasses = `${desktopBaseBtn} ${theme?.primary || 'bg-emerald-600'} text-white shadow-lg shadow-slate-900/25`;
              const inactiveClasses = `${desktopBaseBtn} ${darkMode ? 'text-slate-300 hover:text-white hover:bg-slate-800/60' : 'text-slate-500 hover:text-slate-900 hover:bg-slate-100'}`;

              return (
                <button
                  key={k}
                  onClick={() => setActiveView(k)}
                  className={isActive ? activeClasses : inactiveClasses}
                >
                  <I className="w-5 h-5" />
                  <span className="text-sm font-medium font-quicksand">{l}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // Mobile: bottom nav (original)
  const mobileContainer = darkMode
    ? 'fixed bottom-0 left-1/2 transform -translate-x-1/2 w-full max-w-md border-t border-slate-800/70 bg-slate-950/95 backdrop-blur-lg z-50'
    : 'fixed bottom-0 left-1/2 transform -translate-x-1/2 w-full max-w-md border-t border-slate-200 bg-white/95 backdrop-blur-lg z-50';
  const mobileBaseBtn = 'py-2.5 flex flex-col items-center gap-1 rounded-2xl text-[11px] font-semibold transition-all duration-200';

  return (
    <div className={mobileContainer}>
      <div className={`grid grid-cols-${navItems.length} px-4 py-2`}>
        {navItems.map(({ k, i: I, l }) => {
          const isActive = activeView === k;
          const activeClasses = darkMode
            ? `${mobileBaseBtn} ${theme?.primary || 'bg-emerald-600'} text-white shadow-lg shadow-slate-900/40`
            : `${mobileBaseBtn} ${theme?.primary || 'bg-emerald-600'} text-white shadow-lg shadow-emerald-200/80`;
          const inactiveClasses = `${mobileBaseBtn} ${darkMode ? 'text-slate-300 hover:text-white' : 'text-slate-500 hover:text-slate-900'}`;

          return (
            <button
              key={k}
              onClick={() => setActiveView(k)}
              className={isActive ? activeClasses : inactiveClasses}
            >
              <I className="w-5 h-5" />
              <span className="text-xs font-medium font-quicksand">{l}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NavigationBar;
